<template>
  <div class="buybox-purchase-info">
    <div class="buybox-purchase-info__price-wrapper">
      <!-- Price -->
      <ProductPrice :product="product" :selectedFirstOption="selectedFirstLevelOption" />

      <!-- Klarna and afterpay payment method -->
      <PaymethodsLabel
        :product="product"
        :productForm="productForm"
      />
    </div>

    <div class="buybox-purchase-info__product-options-wrapper">
      <!-- Product Options: will remove dependency of isImageTypeSwatch because new product option does not require images -->
      <ProductOptions
        :product="product"
        :selectedOptions="productForm"
        :isSecondTurn="isSecondTurn"
        @on-option-change="handleOptionChange"
      />
    </div>

    <div class="buybox-purchase-info__atc-wrapper" data-stio-gtm-id="PDP: ATC CTA">
      <!-- <ProductAtC -->
      <ProductATC
        :product="product"
        :productForm="productForm"
        :selectedVariant="productForm.selectedVariant"
        :selectedFirstOption="selectedFirstLevelOption"
        @on-atc-state-change="onATCStateChange"
      />

      <!-- Product Stock Info -->
      <ProductStockInfo
        :isATCDisabled="isATCDisabled"
        :product="product"
        :selectedVariant="productForm.selectedVariant"
        :selectedFirstOption="selectedFirstLevelOption"
      />

      <!-- Callout test -->
      <div class="buybox-purchase-info__callout-wrapper" v-if="!isGiftCard" v-for="(callout, index) in product.callouts" :key="index">
        <div class="buybox-purchase-info__callout">
          <div class="buybox-purchase-info__callout-icon-wrapper">
            <ImageField
              v-if="callout.icon"
              class="buybox-purchase-info__callout-icon"
              :obj="{'url': callout.icon, 'alt': callout.title, 'width': 40, 'height': 40}"
              :load="true"
            />
          </div>
          <div class="buybox-purchase-info__callout-content-wrapper">
            <p v-if="callout.title" class="buybox-purchase-info__callout-title">
              {{ callout.title }}
            </p>
            <p v-if="callout.content" class="buybox-purchase-info__callout-content">
              {{ callout.content }}
              <a v-if="callout.view_details_url" :href="callout.view_details_url" target="_blank">View details</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { reactive, computed, ref } from 'vue';
  import { useStore } from 'vuex';
  import ProductPrice from './product-price.vue';
  import ProductOptions from '../../product-options/index.vue';
  import ProductATC from './product-atc.vue';
  import ProductStockInfo from './product-stock-info.vue';
  import ImageField from '../../global/image.vue';
  import PaymethodsLabel from './paymethods-label.vue';

  const props = defineProps({
    product: {
      type: Object,
      default: () => ({}),
    },
    isSecondTurn: {
      type: Boolean,
      default: false,
    },
  });

  const store = useStore();
  const isATCDisabled = ref(false);
  const product = reactive(props.product);
  const productForm = reactive(store.state.pdp.productForm);
  
  const selectedFirstLevelOption = computed(() => store.state.pdp.firstLevelOptions?.[product.id]);
  const isGiftCard = computed(() => product.title.includes('E-Gift Card'));

  const emit = defineEmits(['on-option-change']);

  const handleOptionChange = (...args) => {
    emit('on-option-change', ...args);
  };

  const onATCStateChange = (value) => {
    isATCDisabled.value = value;
  };
</script>
